import React from 'react';
import $ from 'jquery';
import Typical from 'react-typical';
const steps = [
  'Web developer',1000,
   'Web designer', 1000,
   'Programmer',1000,
    'ML Enthusiast',1000,
  // 'I am react-typical', 1000,
  // 'I can support emoji 👌', 1000,
  // 'I can only delete what needs deleting', 1000,
  // 'I can pause', 4000,
  // 'I can loop', 1000,
  // 'I can wait', 3000,
  // 'I can vary typing speed', 2000,
  // 'Install me now', 1000,
  // 'npm install --save react-typical'
];
const intro = () => {
  let ss = false;
  function toggleMenu() {
    let menuBtn = document.getElementById('menu');
    let navbar = document.getElementById('nabar');
    if (!ss) {
      menuBtn.classList.add('close');
      // navbar.classList.add('show');
      navbar.classList.add('show');
      let cur=document.querySelector('html');
      cur.style.cursor="none";
      if(document.querySelector('#neon p').innerHTML==="Dark")
      {
        let ula=document.querySelector('.show');
        ula.style.background="#d9dbea";
      }
      
      else{
        let ula=document.querySelector('.show');
        ula.style.background="#080d32";
      }
      console.log(menuBtn);
      ss = true;
    }
    else {
      // navbar.style.background="transparent";
      // let whol=document.getElementsByClassName('whol');
      // whol.classList.add('.cursor2');
      let cur=document.querySelector('html');
      cur.style.cursor="auto";
      menuBtn.classList.remove('close');
      let ula=document.querySelector('#nabar');
        ula.style.background="transparent";
      navbar.classList.remove('show');
      ss = false;
    }
  }
  function call() {
    //   let y=document.querySelector('.whole');
    if (document.querySelector('#load').style.display == "none") {
      $('html').css('overflow-y', 'auto');
      console.log('nio');
    }
  }
  (function () {

    const link = document.querySelectorAll('nav > .hover-this');

    const animateit = function (e) {
      const span = this.querySelector('span');
      const { offsetX: x, offsetY: y } = e,
        { offsetWidth: width, offsetHeight: height } = this,

        move = 25,
        xMove = x / width * (move * 2) - move,
        yMove = y / height * (move * 2) - move;

      span.style.transform = `translate(${xMove}px, ${yMove}px)`;

      if (e.type === 'mouseleave') span.style.transform = '';
    };



    link.forEach(b => b.addEventListener('mousemove', animateit));
    link.forEach(b => b.addEventListener('mouseleave', animateit));
    // 

  })();
  const editCursor = e => {
    const cursor = document.querySelector('.cursor');
    const { clientX: x, clientY: y } = e;
    
      cursor.style.left = x + 'px';
      cursor.style.top = y + 'px';
    
  };

  window.addEventListener('mousemove', editCursor);
  return (
    <>
      <div className="whol" id="who" onMouseEnter={() => call()}>
        <div className="whole container-fluid" id="first">
        {/* <div className="cursor"></div> */}
          <header id="nabar">
            <nav>
              <ul>
                <li><a href="#first" className="link hover-this"><span>Home</span></a></li>
                <li><a href="#second" className="link hover-this"><span>About</span></a></li>
                <li><a href="#third" className="link hover-this"><span>Projects</span></a></li>
                <li ><a href="#contact_me" className="link hover-this"><span>Contact</span></a></li>
                <div className="cursor"></div>
              </ul>
            </nav>
          </header>
          <header>
            <div class="menu-btn" id="menu" onClick={toggleMenu}>
              <div class="btn-line"></div>
              <div class="btn-line"></div>
              <div class="btn-line"></div>
            </div>
          </header>
          <div>
            <div className="introsvg  ">
              <div className="container heading">
                {/* <div className="cursor"></div> */}
                <h2><span className="bold">&lt;b&gt;</span> Hi<span className="bold">&lt;/b&gt;</span></h2>
                <span><h1>I'm <span className="bold" id="name1">Avishake Maji</span></h1></span>
                <div id="skill"><p>I am a <Typical wrapper="span" steps={steps} loop={500} className={'caca'} /></p></div>
                <span className="logo">
                  <a href="https://github.com/Avishake007" target="blank"><i className="fa fa-github" aria-hidden="true" /></a>
                  {/* <i className="fa fa-facebook" aria-hidden="true"></i> */}
                  <a href="https://www.linkedin.com/in/avishake-maji-8b477b191/" target="blank"><i className="fa fa-linkedin" aria-hidden="true"></i></a>

                </span>

              </div>
              <div className="second animate__animated animate__zoomIn" ><div id="image" >
                <div >
                  <svg width="1015" height="814" viewBox="0 0 1015 814" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="undraw_dev_productivity_umsq 1" clip-path="url(#clip0)" filter="url(#filter0_d)">
                      <path id="face" d="M543.459 231.991C595.075 231.991 636.919 193.49 636.919 145.996C636.919 98.5015 595.075 60 543.459 60C491.843 60 450 98.5015 450 145.996C450 193.49 491.843 231.991 543.459 231.991Z" fill="#D18F98" />
                      <path id="neck" d="M473.147 182C473.147 182 490.756 304.139 463.666 317.848C436.577 331.557 624.85 332.804 624.85 332.804C624.85 332.804 582.861 226.867 601.823 194.463L473.147 182Z" fill="#D18F98" />
                      <path id="Vector" d="M755.835 332.886L740.177 398.491L707.07 537.292L706.078 544.893L694.653 632.893L687.053 691.353L681.956 730.622C650.971 745.275 628.513 755.391 628.513 755.391C628.513 755.391 626.582 746.48 623.468 735.078C601.722 741.077 561.485 751.029 527.385 753.017C539.802 765.752 545.509 777.715 537.769 786.545C514.409 813.161 417.971 757.402 384.241 736.61C383.455 741.588 383.157 746.621 383.351 751.649L357.538 733.382L360.093 691.353L364.401 620.239L369.815 531.058C368.108 527.24 366.677 523.321 365.532 519.329C357.627 493.461 348.032 441.807 340.673 398.491C334.75 363.631 330.302 334.173 329.362 327.904C329.235 327.086 329.171 326.665 329.171 326.665L472.062 268.567C482.217 290.237 529.635 296.751 529.635 296.751C568.92 294.26 599.714 275.198 599.714 275.198L755.835 332.886Z" fill="#B0B9BC" />
                      <path id="Vector_2" d="M656.97 730.47C656.97 730.47 650.92 732.376 641.083 735.078C619.338 741.077 579.1 751.029 545.001 753.017C515.642 754.748 490.834 750.585 486.297 732.961C484.352 725.383 487.11 719.15 493.122 714.028C511.067 698.72 557.939 693.236 595.114 691.353C605.612 690.827 615.321 690.581 623.405 690.487C637.131 690.324 646.129 690.581 646.129 690.581L646.345 691.353L656.97 730.47Z" fill="#D18F98" />
                      <path id="righthand" d="M875.036 634.495C865.517 643.991 841.928 658.293 813.333 673.776C802.695 679.53 791.371 685.459 779.818 691.353C752.252 705.421 723.389 719.361 699.572 730.622C668.586 745.275 646.129 755.391 646.129 755.391C646.129 755.391 644.197 746.48 641.083 735.078C636.915 719.817 630.636 700.088 624.091 691.353C623.862 691.049 623.633 690.768 623.405 690.487C621.498 688.184 619.579 686.839 617.685 686.839L712.268 632.893L753.141 609.574L723.694 544.893L686.761 463.758L709.053 398.492L731.459 332.886H773.451C773.451 332.886 787.355 360.812 805.135 399.755C807.791 405.578 810.537 411.648 813.333 417.916C849.91 499.776 895.511 614.088 875.036 634.495Z" fill="#B7B1DC" />
                      <path id="Vector_3" d="M555.384 786.545C532.025 813.161 435.586 757.402 401.856 736.61C394.51 732.084 390.138 729.219 390.138 729.219L420.996 691.353L430.77 679.366C430.77 679.366 439.514 683.634 452.439 690.581C452.909 690.838 453.379 691.095 453.862 691.353C465.009 697.375 479.001 705.246 493.122 714.028C512.605 726.155 532.304 739.989 545.001 753.017C557.418 765.752 563.124 777.715 555.384 786.545Z" fill="#D18F98" />
                      <path id="lefthand" d="M452.439 690.581C448.99 690.569 445.546 690.827 442.144 691.353C412.926 695.972 404.309 720.308 401.856 736.61C401.071 741.588 400.773 746.621 400.966 751.649L375.154 733.382L365.749 726.728C343.114 719.466 322.944 706.567 305.456 691.353C290.285 677.921 276.676 663.07 264.85 647.043C253.07 631.246 242.569 614.673 233.432 597.459C230.883 592.655 229.512 587.394 229.418 582.049C229.323 576.704 230.507 571.405 232.886 566.527L264.85 500.981L311.569 405.181C311.912 402.9 312.289 400.671 312.7 398.492C321.965 349.609 346.786 327.905 346.786 327.905H365.749L378.433 398.492L394.192 486.187L383.148 519.329L357.627 595.868L382.017 620.239L452.439 690.581Z" fill="#B7B1DC" />
                      <path id="Vector_4" d="M473.9 486.257L490.111 503.659C496.134 502.603 502.423 501.361 508.901 499.967L504.245 486.257L515.629 498.478C584.256 482.947 669.319 452.752 669.319 452.752C669.319 452.752 577.485 458.948 508.917 445.164C478.579 439.065 447.365 452.903 434.915 479.08C427.679 494.295 428.815 507.477 454.48 507.477C463.152 507.341 471.799 506.593 480.347 505.239L473.9 486.257Z" fill="#EF7272" />
                      <path id="laptop" d="M810.175 513.012H598.638V509H502.718V513.012H290.309C286.514 513.012 282.874 514.399 280.191 516.868C277.508 519.337 276 522.686 276 526.178V792.705C276 796.197 277.508 799.546 280.191 802.015C282.874 804.484 286.514 805.872 290.309 805.872H810.175C813.97 805.872 817.61 804.484 820.293 802.015C822.976 799.546 824.484 796.197 824.484 792.705V526.178C824.484 524.449 824.114 522.737 823.395 521.139C822.676 519.542 821.622 518.091 820.293 516.868C818.964 515.645 817.387 514.676 815.651 514.014C813.915 513.352 812.054 513.012 810.175 513.012V513.012Z" fill="#45435A" />
                      <path id="Vector_5" d="M170.305 805.74H134.719V838.484H170.305V805.74Z" fill="#B7B1DC" />
                      <path id="hair" d="M460.701 57.1173L443.254 50.6808C443.254 50.6808 479.733 13.671 530.487 16.8894L516.212 2.40718C516.212 2.40718 551.105 -10.4657 582.826 23.3257C599.501 41.0891 618.794 61.9691 630.821 85.4901H649.505L641.707 101.313L669 117.136L640.986 114.294C642.656 122.959 642.912 131.805 641.747 140.539C640.545 149.276 635.707 157.242 628.253 162.754V162.754C628.253 162.754 606.616 121.482 606.616 115.045V131.137C606.616 131.137 589.17 116.655 589.17 107L579.653 118.264L574.895 100.563L516.212 118.264L525.728 103.782L489.249 108.609L503.524 90.9087C503.524 90.9087 462.287 111.827 460.701 129.528C459.115 147.228 447.045 164 447.045 164C447.045 164 414.706 81.254 460.701 57.1173Z" fill="#2F2E41" />
                    </g>
                    <defs>
                      <filter id="filter0_d" x="-4" y="0" width="1023" height="814" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                      </filter>
                      <clipPath id="clip0">
                        <rect width="1015" height="806" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                </div>
              </div></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default intro;